module.exports = __webpack_public_path__ + "plat/static/img/title.a8863b30.png";